const transformHotkeyToRuleArray = (hotkey) => {
  if (!hotkey) {
    return [];
  }

  return Array.isArray(hotkey) ? hotkey : hotkey.split('');
};

const convertBarcodeToArray = (barcode) => {
  const wildcardIndex = barcode.indexOf('**');
  if (wildcardIndex > -1) {
    return [
      ...barcode.toLowerCase().split('').slice(0, wildcardIndex),
      '**',
      ...barcode
        .toLowerCase()
        .split('')
        .slice(wildcardIndex + 2),
    ];
  }
  return barcode.toLowerCase().split('');
};

export const transformHotkeysToEngineRules = (activeHotkeys, transformableHotkey) => {
  const { hotkey, partialMatch, barcode, handler, matches } = transformableHotkey;
  const hotkeyArray = transformHotkeyToRuleArray(hotkey);
  activeHotkeys.push({
    hotkeyReference: transformableHotkey,
    hotkeyArray,
    partialMatch: partialMatch || hotkeyArray,
    matches,
    handler,
  });

  if (barcode) {
    const barcodeArray = convertBarcodeToArray(barcode);

    activeHotkeys.push({
      hotkeyReference: transformableHotkey,
      partialMatch: barcodeArray,
      hotkeyArray: barcodeArray,
      matches,
      handler,
      barcode: true,
    });
  }

  return activeHotkeys;
};
